import { html, css, unsafeCSS } from 'lit';
import styles from './lightbox.scss?inline';
import { ref, createRef } from 'lit/directives/ref.js';
import SotbitModal from '../default';

export default class SotbitModalLightbox extends SotbitModal {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        open: { type: Boolean, reflect: true },
        threshold: { type: Number },
    };

    constructor() {
        super();

        this._footerSlotRef = createRef();
    }

    _handleClose() {
        this.hide();
    }

    _checkFooterVisibility() {
        const footerNodes = this._footerSlotRef?.value?.assignedNodes();
        const newIsShowFooter = footerNodes?.length > 0;

        if (newIsShowFooter !== this.isShowFooter) {
            this.isShowFooter = newIsShowFooter;
            this._isNeedUpdate = true;
        }
    }

    _handleSlotChange() {
        this._checkFooterVisibility();

        if (this._isNeedUpdate) {
            this._isNeedUpdate = false;
            this.requestUpdate();
        }
    }

    _handleKeyDown(event) {
        if (this.open && event.key === 'Escape') {
            this._handleClose();
        }
    }

    render() {
        return html` <sotbit-overlay
                part="overlay"
                class="overlay"
                fixed
                ${ref(this._overlayRef)}
                @click="${this._handleClose}"
            ></sotbit-overlay>
            <div class="wrapper" @slotchange="${this._handleSlotChange}">
                <div class="header">
                    <sotbit-button-icon
                        background
                        outline
                        @click="${this._handleClose}"
                        variant="secondary"
                        theme="dark"
                        class="close-btn"
                        part="close-btn"
                    >
                        <sotbit-icon
                            class="close-icon"
                            part="close-icon"
                            slot="content"
                            icon="close"
                            size="m"
                            no-padding
                        ></sotbit-icon>
                    </sotbit-button-icon>
                </div>
                <div class="body">
                    <div class="content">
                        <slot></slot>
                    </div>
                </div>
                <div class="footer ${this.isShowFooter ? '' : 'empty'}">
                    <div class="footer-content">
                        <slot name="footer" ${ref(this._footerSlotRef)}></slot>
                    </div>
                </div>
            </div>`;
    }
}
